module.exports = __webpack_public_path__ + "static/assets/311ef566eba52b1729fd02d8944b4378.mp3";